import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppCoreService } from 'src/app/services/app-core.service';
import { LoginService } from 'src/app/services/login.service';
import Swal from 'sweetalert2';
import { EmailValidation } from '../../models/validator'; 
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PasswordValidators } from 'src/app/models/password-validators';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  confirmPasswordForm: FormGroup;
  formSubmitted = false;
  isConfirmFormSubmitted = false;
  year: number = new Date().getFullYear();
  error = '';
  showOtpVerify = false;
  showToChangePassword = false;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    // inputStyles: {
    //   'width': '80px',
    //   'height': '50px'
    // }
  };
  hidePassword = true;
  hideconfirmpassword = true;
  userId: number = null;
  userName: string = '';
  otpValue: number;
  userEmailId: string = '';

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private appCoreService: AppCoreService,
    private ngxLoaderService: NgxUiLoaderService,
  ) { }

  ngOnInit(): void {
    this.forgotPasswordForm = this.formBuilder.group({
      ddlLoginAs: ['Client'],
      txtClientId: [null, Validators.compose([Validators.required, Validators.maxLength(10)])],
      txtEmail: [null, Validators.compose(
        [EmailValidation, Validators.required])]
    });
    this.confirmPasswordForm = this.formBuilder.group({
      txtPassword: [null, Validators.compose([
                          Validators.required,
                          Validators.minLength(8),
                          Validators.maxLength(20),
                          PasswordValidators.patternValidator(new RegExp("(?=.*[0-9])"), {
                              requiresDigit: true
                         }),
                         PasswordValidators.patternValidator(new RegExp("(?=.*[A-Z])"), {
                          requiresUppercase: true
                        }),
                        PasswordValidators.patternValidator(new RegExp("(?=.*[a-z])"), {
                          requiresLowercase: true
                        }),
                        PasswordValidators.patternValidator(new RegExp("(?=.*[$@^!%*?&])"), {
                          requiresSpecialChars: true
                        })
                      ])],
      txtConfirmPassword: [null, Validators.required]
    }, { validators: this.matchPasswordValidator })
  }

  matchPasswordValidator(control: FormGroup): { [key: string]: boolean } | null {
    const password = control.get('txtPassword')?.value;
    const confirmPassword = control.get('txtConfirmPassword')?.value;
    return password === confirmPassword ? null : { 'mismatch': true };
  }

  onOtpChange(data: number) {
    this.otpValue = data;
  }

  onFormSubmit() {
    if (!this.showOtpVerify && !this.showToChangePassword) {
      this.formSubmitted = true;
      if (this.forgotPasswordForm.valid) {
        const reqObj = {
          clientid: this.forgotPasswordForm.get('txtClientId')?.value,
          email: this.forgotPasswordForm.get('txtEmail')?.value
        }
        try {
          this.ngxLoaderService.start();
          this.loginService.ForgotPassword(reqObj).subscribe((res) => {
            if (res && res.success) {
              this.ngxLoaderService.stop();
              this.userId = res.data?.id;
              this.userName = res.data?.username;
              this.showOtpVerify = true;
              this.userEmailId = reqObj.email;
              this.appCoreService.showMessage(`OTP has been sent to ${this.userEmailId}. Please check your mailbox.`, 'Success', 'success');
            } else if (res && !res.success) {
              this.ngxLoaderService.stop();
              this.appCoreService.showMessage(res.message, 'Error', 'error');
            }
          })
        } catch (err) {
          this.ngxLoaderService.stop();
          this.appCoreService.showMessage('An error occurred while generating the OTP !!', 'Error', 'error');
        }
      }
    } else if (this.showOtpVerify && !this.showToChangePassword) {
      if (this.otpValue && this.otpValue.toString().length == this.config.length) {
        const reqObj = {
          clientid: this.forgotPasswordForm.get('txtClientId')?.value,
          id: this.userId,
          otp: this.otpValue
        }

        this.loginService.VerifyOtp(reqObj).subscribe((res) => {
          if (res && res.success) {
            this.showToChangePassword = true;
            this.showOtpVerify = false;
            this.appCoreService.showMessage(`OTP verified successfully`, 'Success', 'success');
          } else if (res && !res.success) {
            this.appCoreService.showMessage(res.message, 'Error', 'error');
          }
        })
      } else {
        this.appCoreService.showMessage('Please provide the OTP', 'Info', 'info')
      }
    } else if (this.showToChangePassword) {
      this.isConfirmFormSubmitted = true;
      if (this.confirmPasswordForm.valid) {
        const reqObj = {
          id: this.userId,
          clientid: this.forgotPasswordForm.get('txtClientId')?.value,
          emailid: this.forgotPasswordForm.get('txtEmail')?.value,
          password: this.confirmPasswordForm.get('txtPassword')?.value
        };

        this.loginService.UpdatePassword(reqObj).subscribe((res) => {
          if (res && res.success) {
            this.userId = null;
            this.userName = null;
            this.showOtpVerify = false;
            this.openSuccessDialog('Your password is updated successfully. You can now login to the portal with new password.');
          } else if (res && !res.success) {
            this.showOtpVerify = false;
            this.appCoreService.showMessage(res.message, 'Error', 'error');
          }
        })
      }
    }
  }

  resendOTP() {
    const reqObj = {
      id: this.userId,
      username: this.userName,
      clientid: this.forgotPasswordForm.get('txtClientId')?.value,
      email: this.forgotPasswordForm.get('txtEmail')?.value
    }
    this.loginService.resendOTP(reqObj).subscribe((res) => {
      if (res && res.success) {
        this.appCoreService.showMessage('OTP send Successfully', 'Successs');
      }
      else if (res && !res.success) {
        this.appCoreService.showMessage('Failed to send OTP ', 'Info', 'info');
      }
    })
  }

  async openSuccessDialog(msg: string) {
    const result = await Swal.fire({
      html: msg,
      icon: 'success',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })

    if (result.isConfirmed) {
      this.router.navigate(['/']);
    }
  }

  cancelOtp() {
    this.showOtpVerify = !this.showOtpVerify;
    this.forgotPasswordForm.reset();
    this.formSubmitted = false;
  }

}
